import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { registerSale } from '../../actions/inventoryActions'
import InventorySaleCartView from '../../containers/Inventory/InventorySaleCart/InventorySaleCart'


const InventorySaleCart = () => {
 const history = useHistory()
  const { bagSales } = useSelector(state => state.inventory)
  const { userInfo } = useSelector(state => state.userInfo)
  const dispatch = useDispatch()
  const register = (identificationNumber) =>{
    let id = "";
    if (userInfo.representativeID) {
      if (userInfo.representativeID.state ===2) {
     
        id = userInfo.representativeID._id
      }
    }
    if (userInfo.franchiseID) {
      if (userInfo.franchiseID.state ===2) {
        id = userInfo.franchiseID._id
      }
    }
    if (userInfo.warehouseID) {
      id = userInfo.warehouseID
      
    }

    dispatch(registerSale(identificationNumber,id,bagSales,history))
  }
  return (
    
    <InventorySaleCartView bag={bagSales} register ={register}/>
  )
}

export default InventorySaleCart